




import {Component, Prop, Vue} from "vue-property-decorator";
import {EmployeeStore} from "../../store";

@Component({
    name: "EmployeeLabel"
})
export default class extends Vue {
    @Prop({ required: true, type: String })
    readonly id!: string;

    get label() {
        return `${EmployeeStore.data[this.id]?.employeeCode} - ${EmployeeStore.data[this.id]?.fullname}`;
    }
}
